module.exports = __webpack_public_path__ + "static/img/cover6.c3f87278.jpg";